import {
  createDailyEventsFromExternalEvents,
  getCalendarEventReferenceDate,
} from '@griply/utils';
import { addDays, endOfDay, isBefore, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useExternalCalendarEventsQuery } from 'shared/hooks/queries/use-external-calendar-events-query';

export const useUpcomingExternalCalendarEvents = () => {
  const today = useToday();
  const endDate = useMemo(() => addDays(endOfDay(today), 9), [today]);
  const { data } = useExternalCalendarEventsQuery(
    startOfDay(today).toISOString(),
    endDate.toISOString(),
  );

  return useMemo(
    () =>
      data?.length
        ? createDailyEventsFromExternalEvents(data)
            // multi-day events can start before the window and surpass its end
            .filter(({ start }) =>
              isBefore(getCalendarEventReferenceDate(start, endDate), endDate),
            )
        : [],
    [data, endDate],
  );
};
